














































































































































import {Component, Prop, VModel, Vue} from "vue-property-decorator";
import SelectOption from "@/components/common/SelectOption";
import {PropType} from "vue";
import PortalInput from "@/components/new_style_components/PortalInput.vue";
import {Md5} from "ts-md5";
import CommonInputMixin from "@/components/new_style_components/mixins/CommonInputMixin.vue";

@Component({
	methods: {
		hashCode(obj: any): string {
			return Md5.hashStr(JSON.stringify(obj))
		},
	},
	components: { PortalInput },
	inheritAttrs: false,
	mixins: [CommonInputMixin],
})
export default class PortalSelect extends Vue {
	@VModel(
		{
			type: [Object, Array, String, Boolean, Number, null] as PropType<any>,
		}
	)
	private select!: any;

	@Prop({ default: false })
	private multiple!: boolean;

	@Prop({ default: false })
	private searchable!: boolean

	@Prop({ default:function () { return () => { return } } })
	private change!: () => void

	@Prop({ default: [] })
	private options!: Array<SelectOption>;

	@Prop({ default: false })
	private disabled!: boolean

	private isOpen = false;
	private searchableSubString = "";

	isNotSelected(option: SelectOption): boolean {
		if (this.model) {
			if (this.multiple) {
				return !(this.model as Array<SelectOption>).find(it => Md5.hashStr(JSON.stringify(it ?? null)) == Md5.hashStr(JSON.stringify(option ?? null)))
			} else {
				return Md5.hashStr(JSON.stringify(this.model.value ?? null)) != Md5.hashStr(JSON.stringify(option.value ?? null))
			}
		} else {
			return true
		}
	}

	private toggle() {
		this.isOpen = !this.isOpen
	}

	private click(option: SelectOption): void {
		if (this.multiple) {
			this.$emit('input', [...(this.model as Array<any>), option].map(val => val.value))
		} else {
			this.$emit('input', option.value)
		}
		this.searchableSubString = ""
		this.toggle();
		this.change();
		this.$emit('change');
	}

	private flush(val: SelectOption) {
		if (this.multiple) {
			this.$emit('input', (this.model as Array<any>).filter(i => i != val).map(val => val.value))
		} else {
			this.$emit('input', undefined)
		}
		this.change()
		this.$emit('change');
		this.searchableSubString = ""
	}

	get model(): any {
		if (this.multiple) {
			if (this.select) {
				return this.options.filter(option => !!(this.select as Array<any>).find(it => Md5.hashStr(JSON.stringify(option.value ?? null)) == Md5.hashStr(JSON.stringify(it ?? null))));
			} else {
				return [];
			}
		} else {
			const res = this.options.find(val => Md5.hashStr(JSON.stringify(val.value ?? null)) == Md5.hashStr(JSON.stringify(this.select ?? null)))
			return res ? res : null;
		}
	}

	get qualifiedOptions(): Array<SelectOption> {
		if (this.searchable && this.searchableSubString != "") {
			return this.options.filter(it => JSON.stringify(it).trim()
				.replaceAll("\"title\":", "")
				.replaceAll("\"value\":", "")
				.toLowerCase()
				.indexOf(this.searchableSubString.toLowerCase()) >= 0
			)
		}
		return this.options
	}
}
